import { DatePipe } from '@angular/common';

export function dateToParam(date: Date | string): string {
  const datepipe: DatePipe = new DatePipe('hu-HU');
  return datepipe.transform(date, 'YYYY-MM-dd') ?? '';
}
